// for mega menu on hover
document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 990) return; // desktop only

  document.querySelectorAll('header-menu details.mega-menu').forEach(details => {
    let timeout;

    details.addEventListener('mouseenter', () => {
      clearTimeout(timeout);
      details.setAttribute('open', '');
    });

    details.addEventListener('mouseleave', () => {
      timeout = setTimeout(() => {
        details.removeAttribute('open');
      }, 150);
    });
  });
});
